module.exports = __webpack_public_path__ + "static/media/trainingsraum-geraete.3e3031c2.jpg";